// frontend/src/components/common/StatusChip.jsx
// Unified chip component for status, severity, priority, and count labels.
//
// The ref and any other props land on the chip's own span, so a MUI Tooltip
// can wrap the chip directly: Tooltip anchors to its child's ref and hands it
// the hover listeners and aria-label as props.

import './StatusChip.css';

// `prominent` is the larger, filled chip that names a whole record's status in
// a page header, so it does not read as one more of the row chips below it.
export default function StatusChip({ label, color = 'neutral', icon, prominent = false, className, ref, ...rest }) {
  const classes = `status-chip status-chip--${color}${prominent ? ' status-chip--prominent' : ''}${className ? ` ${className}` : ''}`;
  return (
    <span ref={ref} className={classes} {...rest}>
      {icon && <span className="status-chip__icon">{icon}</span>}
      {label}
    </span>
  );
}
